// Pick a per-locale market string ({locale: text}) for the active locale.
// Returns undefined when there is no non-empty translation, so callers can
// fall back to the default (English) field / on-demand ApiTranslation.
// Locale codes must match APP_I18N.locales[].lang (e.g. 'zh-cn', 'ja', 'pt').
export function pickLocaleText(
  i18n: Record<string, string> | undefined | null,
  locale: string | undefined
): string | undefined {
  if (!i18n || !locale) return undefined;
  const value = i18n[locale];
  return value && value.trim() ? value : undefined;
}

// Subset of EventLabel (use-event-labels.ts) this helper needs, kept local so
// this utils module doesn't depend on the hooks layer.
type EventTitleSource = {
  eventTitle?: string;
  eventTitleI18n?: Record<string, string>;
  marketNameI18n?: Record<string, string>;
};

// Plain-string counterpart of EventPrimaryTitle (market-event-title.tsx) for
// string-only contexts (e.g. TextTooltip's tooltip prop) — same source
// selection: the event title when the market belongs to an event group,
// otherwise the market's own name.
export const eventPrimaryTitleText = (
  label: EventTitleSource | undefined,
  marketName: string,
  locale: string | undefined
): string => {
  const hasEvent = !!label?.eventTitle;
  const i18n = hasEvent ? label?.eventTitleI18n : label?.marketNameI18n;
  const fallback = hasEvent ? (label!.eventTitle as string) : marketName;
  return pickLocaleText(i18n, locale) ?? fallback;
};
